import React, {useCallback} from 'react';
import {GatewayGetSchema} from '../../../../api/DBSchema/Gateway';
import LockToPlanContainer from '../../../../components/Editor/LockToPlanContainer';
import BaseSiteToSiteVpn from '../../AbstractObjects/GatewayPlan/InnerPages/BaseSiteToSiteVpn';
import {BladesPolicy} from '../../../../api/DBSchema/Enums';
import {useTranslation} from 'react-i18next';
import Indentation from '../../../../components/Simple/Indentation';
import SMCLink from '../../../../components/Simple/SMCLink';
import {doSeamlessLogin} from '../../../../utils/utils';
import SMCIcon from '../../../../components/Simple/SMCIcon';
import {siteToSiteVpnIcon} from "../../../../assets/images/headerIcons";

const pageSchema = GatewayGetSchema.pages.siteToSiteVpn;
const pageId = pageSchema.pageId;

const firewallPageSchema = GatewayGetSchema.pages.firewall;
const firewallPageId = firewallPageSchema.pageId;

function GatewaySiteToSiteVpn({
    gatewayObject,
    planObject,
    setGatewayData,
    setEditorPageId
}) {
    const { t } = useTranslation();

    const gatewayPage = gatewayObject[pageId];
    const planPage = planObject[pageId];
    const lockedToPlan = gatewayPage[pageSchema.lockedToPlan];

    let currentPageData;
    if (lockedToPlan) {
        currentPageData = planPage;
    } else {
        currentPageData = gatewayPage;
    }
    
    const firewallGatewayPage = gatewayObject[firewallPageId];
    const firewallPlanPage = planObject[firewallPageId];
    const firewallLockedToPlan = firewallGatewayPage[firewallPageSchema.lockedToPlan];
    let firewallPageData;
    if (firewallLockedToPlan) {
        firewallPageData = firewallPlanPage;
    } else {
        firewallPageData = firewallGatewayPage;
    }
    
    const isFirewallStrict = firewallPageData[firewallPageSchema.policy] === BladesPolicy.STRICT;

    const onToggleLockedToPlan = useCallback(locked => {
        // If unlocked page from plan, set all gateway fields to plan's fields
        if (!locked) {
            setGatewayData(pageId, planPage);
        }
        setGatewayData([pageId, pageSchema.lockedToPlan], locked);

    }, [setGatewayData, planPage]);


    return (
        <>
        <LockToPlanContainer
            locked={lockedToPlan}
            onToggleLocked={onToggleLockedToPlan}
            labelText={t('SMP.GATEWAYS.INNER_MENU.SITE_TO_SITE_VPN')}
            icon={siteToSiteVpnIcon}
        >
            <BaseSiteToSiteVpn
                pageData={currentPageData}
                setObjectData={setGatewayData}
                pageDisabled={lockedToPlan}
                setEditorPageId={setEditorPageId}
                isFirewallStrict={isFirewallStrict}
            />
        </LockToPlanContainer>
        <Indentation>
            <SMCLink onClick={() => doSeamlessLogin(gatewayObject.id, null, 'app.VPNSite2Site')}><SMCIcon style={{ verticalAlign: 'middle' }} icon="seamlessLogin" /> {t('SMP.ACCESS_GATEWAY.SITE_TO_SITE')}</SMCLink>
        </Indentation>
        </>
    );
}

export default GatewaySiteToSiteVpn;